import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PatientBatchPage } from './patient-batch';
import { DirectivesModule } from '../../directives/directives.module';

@NgModule({
  declarations: [
    PatientBatchPage,
  ],
  imports: [
    IonicPageModule.forChild(PatientBatchPage),
    DirectivesModule
  ],
})
export class PatientBatchPageModule {}



// WEBPACK FOOTER //
// ./src/pages/patient-batch/patient-batch.module.ts